<template>
  <!-- 积分流水 -->
  <div class="integralDetail" style="padding-top: 0.49rem">
    <van-list
      class="ul"
      :style="{ background: finished ? 'none' : '#ffffff' }"
      v-model="loading"
      :finished="finished"
      @load="onLoad"
    >
      <div
        class="integralDetail_list"
        v-for="item in IntegralWaterList"
        :key="item.id"
      >
        <div class="integralDetail_list_content">
          <div>
            <h2
              style="
                font-size: 0.16rem;
                font-weight: bold;
                color: #333333;
                margin-bottom: 0.08rem;
              "
            >
              {{ item.title ? item.title : "--" }}
              <span v-show="item.money >= 0">【收入】</span>
              <span v-show="item.money < 0">【支出】</span>
            </h2>
            <div class="content_middle" style="margin-bottom: 0.08rem">
              <p
                style="
                  width: 2.66rem;
                  font-size: 0.14rem;
                  color: #333333;
                  line-height: 0.2rem;
                "
              >
                {{ item.mark ? item.mark : "--" }}
              </p>
              <p style="font-size: 0.18rem; color: #319f06">
                <span v-show="item.money >= 0"
                  >+{{ item.money ? item.money : "--" }}</span
                ><span v-show="item.money < 0" style="color: #ff5d5d">{{
                  item.money ? item.money : "--"
                }}</span>
              </p>
            </div>
          </div>
          <p style="font-size: 0.12rem; color: #999a9c; margin-bottom: 0.2rem">
            {{ item.ctime ? item.ctime : "--" }}
          </p>
        </div>
        <div class="line"></div>
      </div>
      <!-- 底部的tab切换 -->
      <div class="tabbar">
        <van-tabbar
          v-model="active"
          inactive-color="#333333"
          active-color="#93683D"
        >
          <van-tabbar-item to="/welfare">
            <span>积分商城</span>
            <template #icon="props">
              <img :src="props.active ? icon.active1 : icon.inactive1" />
            </template>
          </van-tabbar-item>
          <van-tabbar-item to="/forRecord">
            <span>兑换记录</span>
            <template #icon="props">
              <img :src="props.active ? icon.active2 : icon.inactive2" />
            </template>
          </van-tabbar-item>
          <van-tabbar-item to="/integralWater">
            <span>积分流水</span>
            <template #icon="props">
              <img :src="props.active ? icon.active3 : icon.inactive3" />
            </template>
          </van-tabbar-item>
        </van-tabbar>
      </div>
    </van-list>
    <!-- 当没有积分流水时 -->
    <div
      v-if="isNone"
      class="noOrder"
      style="
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f3f1f4;
      "
    >
      <img
        src="../../assets/img/empty/img_blank_content@2x.png"
        alt=""
        style="width: 2.17rem; height: 1.75rem; margin-top: 1.16rem"
      />
      <p
        style="
          height: 0.24rem;
          font-size: 0.12rem;
          color: #99999b;
          line-height: 0.24rem;
        "
      >
        您还没有积分流水哦~
      </p>
    </div>
  </div>
</template>

<script>
import { getterIntegralWater } from "../../api/home";
export default {
  data() {
    return {
      IntegralWaterList: [],
      isNone: false,
      loading: false,
      finished: false,
      page: 1,
      active: 2,
      icon: {
        active1: require("../../assets/img/welfare/mall_btn_home_pre@2x.png"),
        inactive1: require("../../assets/img/welfare/mall_btn_home@2x.png"),
        active2: require("../../assets/img/welfare/mall_btn_record_pre@2x.png"),
        inactive2: require("../../assets/img/welfare/mall_btn_record@2x.png"),
        active3: require("../../assets/img/welfare/mall_btn_bill_pre@2x.png"),
        inactive3: require("../../assets/img/welfare/mall_btn_bill@2x.png"),
      },
    };
  },
  created() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.loading = true;
      getterIntegralWater({ page: this.page })
        .then((res) => {
          this.IntegralWaterList.push(...res.data.backdata.lists);
          this.page += 1;
          this.loading = false;
          if (res.data.backdata.lists == 0) {
            this.isNone = true;
          } else {
            this.isNone = false;
          }
          if (this.IntegralWaterList.length >= res.data.ext.total) {
            this.finished = true;
          }
          // console.log(this.IntegralWaterList);
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang='scss'>
.integralDetail {
  padding-bottom: 0.49rem;
  .tabbar {
    height: 0.49rem;
    .van-tabbar {
      height: 0.49rem;
      .van-tabbar-item {
        img {
          width: 0.22rem;
          height: 0.22rem;
        }
        span {
          display: block;
          transform: scale(0.8);
          font-size: 0.125rem;
        }
      }
    }
  }
  .van-tabbar {
    height: 0.49rem;
  }
  .integralDetail_list {
    padding-left: 0.15rem;
    background: #ffffff;

    .integralDetail_list_content {
      width: 100%;
      min-height: 1.29rem;
      background: #ffffff;
      padding: 0.2rem 0.15rem 0 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .content_middle {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .line {
      width: 3.6rem;
      height: 0.01rem;
      background: #f3f1f4;
    }
  }
}
</style>
